var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { style: { display: "flex" } },
    [
      _c(
        "w-link",
        {
          staticClass: "mr btn",
          attrs: { disabled: _vm.previousDisabled },
          on: {
            click: function ($event) {
              return _vm.previous()
            },
          },
        },
        [
          _c("w-fa", { staticClass: "mrs", attrs: { icon: "arrow-left" } }),
          _vm._v("Vorige ticket "),
        ],
        1
      ),
      _c(
        "w-link",
        {
          staticClass: "ml btn",
          attrs: { disabled: _vm.nextDisabled },
          on: {
            click: function ($event) {
              return _vm.next()
            },
          },
        },
        [
          _vm._v(" Volgende ticket "),
          _c("w-fa", { staticClass: "mls", attrs: { icon: "arrow-right" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }